import React from 'react';
import Popup from '../Popup';
import styles from './ConfirmationPopup.styles';
import Button from '../../button/Button';
import Icons from '../../icons/Icons';
import HorizontalSeparator from '../../separator/horizontalSeparator/HorizontalSeparator';
import { BUTTON_TYPE } from '../../button/constants';
import General from '../../../../libs/utility/General';
import Loadable from '../../loadable/Loadable';

export default function ConfirmationPopup({
    title,
    bodyText,
    iconName = '',
    isOpen,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        onCloseCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    customStyle = {},
    isClose = true,
    showClose = true,
    loadingState=false,
    loaderLoadingStates=[],
    loaderMessageMap={},
    preserveLoaderChildMount=false,
    bodyTextCustomStyle = {},
}) {
    return (

        <Popup title={title} onCloseCb={isClose ? cancelButtonProps?.onCancelCb : cancelButtonProps?.onCloseCb} showClose={showClose} isPopupOpen={isOpen} customPopupSyles={customStyle}>
            <Loadable
                currentState={loadingState?.state}
                loadingStates={loaderLoadingStates} 
                isNewLoadable={true}
                messageMap={loaderMessageMap}
                preserveChildMount={preserveLoaderChildMount}
            >
                <div style={styles.bodyContainer}>

                    {iconName && <div>
                        <Icons familyName='vec' iconName={iconName} />
                    </div>}

                    {bodyText && <span style={styles.bodyText}>{<p style={{...styles.innerHtmlContent, ...bodyTextCustomStyle}} dangerouslySetInnerHTML={{ __html: General.sanitizeContent(bodyText) }} />}</span>}

                </div>

                <HorizontalSeparator style={styles.separatorLine} />

                <div style={styles.footer}>

                    {confirmationButtonProps.confirmationButtonText && <div onClick={confirmationButtonProps.onConfirmationCb}>
                        <Button
                            type={confirmationButtonProps.confirmationButtonType}
                            style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.button }}
                        >
                            {confirmationButtonProps.confirmationButtonText}
                        </Button>
                    </div>}

                    {
                        cancelButtonProps !== null && <div onClick={cancelButtonProps.onCancelCb}>
                            <Button
                                type={cancelButtonProps.cancelButtonType}
                                style={{ ...cancelButtonProps.cancelButtonStyles, ...styles.button }}
                            >
                                {cancelButtonProps.cancelButtonText}
                            </Button>
                        </div>
                    }

                </div>
            </Loadable>
        </Popup>
    )
}